import get from 'lodash/get';

/**
 * Merges checked-out employee stay history with upcoming trips for room-night
 * summary calculation, deduplicating by reservationId.
 *
 * Checked-out bookings take precedence. Upcoming trips that share a
 * reservationId (e.g. CHECKEDOUT on departure day) are excluded.
 */
export default function combineEmployeeBookingsForRoomNights(
	checkedOutBookings = [],
	upcomingTrips = []
) {
	const seenReservationIds = new Set(
		checkedOutBookings
			.map(booking => get(booking, ['hotelProducts', 0, 'reservationId']))
			.filter(Boolean)
	);

	const uniqueUpcoming = upcomingTrips.filter(booking => {
		const reservationId = get(booking, ['hotelProducts', 0, 'reservationId']);
		return reservationId && !seenReservationIds.has(reservationId);
	});

	return [...checkedOutBookings, ...uniqueUpcoming];
}
